export default "__VITE_ASSET__ER3hu_nc__";